import { publicApi } from './client';

export const calculatorAPI = {
  byRace: (distance, time) => publicApi.get('/calculator/', { params: { distance, time } }),
  byVdot: (vdot) => publicApi.get('/calculator/', { params: { vdot } }),
};